// @ts-nocheck
export function dataClone(data) {
  return JSON.parse(JSON.stringify(data));
}
